module.exports = __webpack_public_path__ + "static/media/shrimp.4c6f9acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/shrimp.jpg
// module id = 108
// module chunks = 0